require('./fiocView.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
const { formatText, FormattedText, getFinalTitle } = require('core/i18n').i18n;
const Immutable = require('immutable');
const PureRenderMixin = require('react-addons-pure-render-mixin');

// @helpers
const { 
    tagFiocPersonalInfoStart, 
    dataProtectionLink,
    buttonNextTagging,
    buttonCancelTagging,
    fiocErrorTagging,
    fiocRequestNewOTPTagging,
    fiocPreviousButtonTagging,
    fiocCancelButtonTagging,
    fiocUpdateButtonTagging,
    fiocOTPErrorTagging,
    fiocUpdateErrorView,
    fiocUpdateDocumentSuccessTagging,
    fiocUpdateDocumentReturnGlobalTagging,
    fiocOpenCancelModalTagging,
    fiocCloseCancelModalTagging,
    fiocLeaveModalTagging,
    fiocIntroduceOTPTagging,
    fiocStepTwoViewTagging,
} = require('utilities/taggingInfo/fiocTags');
const { getFiocInformation } = require('./utilities/fiocHelper');

// @ actions
const contractsActions = require('actions/contracts');
const fiocDocumentation = require('actions/fiocDocumentation');
const interstitialsActions = require('actions/interstitialGeneric');

// @components
const ContactInfoBox = require('components/myProfile/contactInfoBox/contactInfoBox');
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const WizardError = require('components/commons/wizardError/wizardError');
const { OKCover } = require('commonsComponents/OKCover');
const { OKIconIllustrative } = require('commonsComponents/OKIconIllustrative');
const { OKLink } = require('commonsComponents/OKLink');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKMessage } = require('commonsComponents/OKMessage');
const { CallMeBack } = require('components/callMeBack/callMeBack');
const PendingDocumentation = require('./components/PendingDocumentation/PendingDocumentation');
const PreLeaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');

// @commons
const { HTMLSafeInjector } = require('commonsComponents/htmlSafeInjector');
const openbankLogo = require('assets/images/Openbank_logo_blanco.svg');

// Local components
const ContractConfirmationStep = require('routes/contractsView/components/ContractConfirmationStep/ContractConfirmationStep');//UNCOMMENT WHEN OTP NEEDED
const { ContractComponent } = require('routes/contractsView/components/ContractComponent/ContractComponent');

const contractBuilder = require('routes/contractsView/libs/contractBuilder');

let current_contract;

let fiocFlow = require('routes/contractsView/flows/fioc/fioc');

class FiocView extends React.Component {
    constructor(props) {
        super(props);
        current_contract = this.props.immProfileFields.get('clientProfile') === 2 ? Immutable.fromJS(fiocFlow.contractTC).toJS() : Immutable.fromJS(fiocFlow.contract).toJS();
        this.state = { ...current_contract.state, nextButtonDisabled: false, loading: true};

        this.isReady = this.isReady.bind(this);
        this.beforeLeaving = this.beforeLeaving.bind(this);
        this.handleConfirmLeave = this.handleConfirmLeave.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.nextStep = this.nextStep.bind(this);
        this.handleHireContract = this.handleHireContract.bind(this);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.getFiocInformationForm = this.getFiocInformationForm.bind(this);
        this.handleNextClick = this.handleNextClick.bind(this);
        this.handleReturnToGlobalPositionClick = this.handleReturnToGlobalPositionClick.bind(this);
        this.handleComponentDidMountCallback = this.handleComponentDidMountCallback.bind(this);

    }

    componentWillMount() {
        const {
            contractWizard,
            getCountries,
            reset,
        } = this.props;
        reset();

        if (contractWizard.get('countries').size === 0) {
            getCountries();
        }
    }

    componentDidMount() {
        const {
            contractWizard,
            getFiocContent,
            getProfessionCnaeUncategorized,
            getProfessionCnaeCategory,
            getSectorSubcategories,
            loadState,
            setContract,
            setInProgress,
        } = this.props;
        setContract('fioc');
        getFiocContent();
        let initialLoad = Object.assign({ steps: current_contract.steps }, this.state);

        if (current_contract.initState) {
            initialLoad = contractBuilder[current_contract.initState](initialLoad);
        }
        loadState(initialLoad);
        const formTarget = contractWizard.get('form_target');
        const immCardDetails = contractWizard.get('card_details');

        tagFiocPersonalInfoStart();
        setInProgress();

        if (formTarget) {
            const formList = immCardDetails.find(targetValue => targetValue.id === formTarget).value;
            if (formList.length >= 1) {
                formList.forEach(form => {
                    this.state.card_details.find(formObject => formObject.id === form).value = [];
                });
            }
        }

        if (contractWizard.get('professionCnaeUncategorized').size === 0) {
            getProfessionCnaeUncategorized();
        }
        if (contractWizard.get('professionCnaeCategories').size === 0) {
            getProfessionCnaeCategory();
        }
        if (contractWizard.get('professionSectorSubcategories').size === 0) {
            getSectorSubcategories();
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const isCnaeFetching = this.props.contractWizard.get('professionCnaeUncategorizedIsFetching');
        if (!isCnaeFetching && prevProps.contractWizard.get('professionCnaeUncategorizedIsFetching') !== isCnaeFetching) {
            this.getFiocInformationForm();
        }
    }

    componentWillReceiveProps(nextProps) {
        const cardDetails = nextProps.contractWizard.get('card_details');
        
        this.setState({
            card_details: cardDetails && cardDetails.toJS()
        });
    }

    async getFiocInformationForm() {
        const copiedCardDetails = JSON.parse(JSON.stringify(this.state.card_details));
        try {
            const fiocData = await getFiocInformation();
            if (fiocData.workFor && fiocData.workFor === '02') {
                copiedCardDetails[4].value = 1;
                this.props.updateCardDetails(copiedCardDetails)
            }

            const transformedFiocFields = this.props.parseFiocData(fiocData);
            transformedFiocFields.forEach(({position, value}) => {
                copiedCardDetails[position].value = value;
                if(position === 48 && value === true) {
                    copiedCardDetails[48].disabled = value;
                }
            })
            
            this.props.updateCardDetails(copiedCardDetails)
        }
        catch(error) {}
        finally {
            this.setState({ loading: false })
        }
    }

    handleReturnToGlobalPositionClick() {
        fiocUpdateDocumentReturnGlobalTagging();
        this.props.history.push('/myprofile/edit');
    }

    handleNextClick() {
        buttonNextTagging(this.state.card_details[4].value);
    }

    handleHireContract() {
        const { contractWizard } = this.props;

        fiocUpdateButtonTagging();
        const params = contractBuilder[current_contract.hireParamsFn](contractWizard);
        this.props.fiocUpdate(params);
    }

    beforeLeaving() {
        this.props.reset();
    }

    buildDescription(step) {
        let description = step.description && <FormattedText value={step.description} />;
        description = description && step.descriptionBold ? <strong>{description}</strong> : description;

        return <p className='fioc-view__wizard__description'>{description}</p>;
    }

    buildError() {
        const goBackButton = {
            onMainButtonClick: this.handleReturnToGlobalPositionClick,
            label: <FormattedText className='text-uppercase' value='profileFioc-goBackButton' />,
            url: '/myprofile/edit',
        };

        return (
            <WizardError
                errorMessage={formatText('profileFioc-errorStepTitle')}
                mainButton={goBackButton}
                {...(!this.props.immScreen.get('isDesktop') && { onMainButtonClick: this.handleConfirmFinishFIOC })}
                onComponentDidMountCallback={fiocUpdateErrorView}
                onMainButtonClick={ this.handleReturnToGlobalPositionClick }
            >
                <FormattedText value='profileFioc-errorStepText' />
            </WizardError>
        );
    }

    buildFormError() {
        const { contractWizard } = this.props;
        const isValidStep = contractWizard.getIn(['twoStepValidation', 0]);
        const visibleStep = contractWizard.get('visibleStep');
        let formError;

        if (isValidStep === false && visibleStep === 1) {
            formError = (
                <OKMessage type='informative'>
                    <FormattedText value='profileFioc-formStepWarningMessage' />
                </OKMessage>
            );
        }
        return formError;
    }

    buildDisclaimerPersonalInfo() {
        const link = formatText('disclaimerPersonalInfo-fiocUpdateLinkUrl');
        return (
            <div className='fioc-view__disclaimer-gdpr'>
                <OKMessage type='informative'>
                    <FormattedText value='disclaimerPersonalInfo-fiocUpdateMsg' />
                    &nbsp;
                    <OKLink modifier='emphasize' to={link} target='_blank' onClick={dataProtectionLink}>
                        <FormattedText value='disclaimerPersonalInfo-fiocUpdateLinkText' />
                    </OKLink>
                </OKMessage>
            </div>
        );
    }

    buildHeaderSubPage() {
        const { breadcrumb, title } = current_contract;
        const immCardDetails = this.props.contractWizard.get('card_details');
        let headerSubPage;

        if (immCardDetails || (!contractBuilder[breadcrumb] && !contractBuilder[title])) {
            const contractBreadcrumb = contractBuilder[breadcrumb]
                ? contractBuilder[breadcrumb](immCardDetails)
                : breadcrumb;
            const contractTitle = contractBuilder[title]
                ? contractBuilder[title](immCardDetails)
                : title;
            const mappingBreadcrumb = contractBreadcrumb.map(item => ({
                text: <FormattedText value={item.text} />,
                url: item.url || '',
            }));

            headerSubPage = (
                <OKHeaderSubPage
                    breadcrumbConfig={mappingBreadcrumb}
                    finalTitle={getFinalTitle(contractTitle)} />
            );
        }

        return headerSubPage;
    }

    buildPreLeaveModal() {
        const confirmationTitle = formatText('wizard-redirectConfirmationTitle');
        const confirmationMessage = formatText('wizard-redirectConfirmationMessage');
        const acceptText = formatText('wizard-redirectConfirmationAcceptButton');
        const cancelText = formatText('wizard-redirectConfirmationCancelButton');
        return (
            <PreLeaveModalComponent
                className={`${!this.props.immScreen.get('isDesktop') && 'preleave-modal-mobile'}`}
                externalLink='/myprofile/global/'
                confirmationMessage={confirmationMessage}
                confirmationTitle={confirmationTitle}
                acceptText={acceptText}
                cancelText={cancelText}
                isReady={this.isReady}
                beforeLeaving={this.beforeLeaving}
                onConfirmLeave={this.handleConfirmLeave}
                onAfterOpen={fiocOpenCancelModalTagging}
                onCloseCallback={fiocCloseCancelModalTagging}
            />
        );
    }

    disableFinishButton = (disable) => {
        this.setState({ nextButtonDisabled: disable });
    };

    buildStep(step) {
        const { contractWizard } = this.props;
        const component = step.components[0];
        const stepFooter = this.buildStepFooter(step);
        const title = step.title && <FormattedText value={step.title} />;
        const subtitle = step.subtitle && <FormattedText value={step.subtitle} />;
        const description = this.buildDescription(step);
        const formError = this.buildFormError();
        const disclaimerPersonalInfo = step.position === 'first' ? this.buildDisclaimerPersonalInfo() : null;
        return (
            <WizardStep
                key={step.position}
                position={step.position}
                confirmBackClick={this.handleConfirmBackClick.bind(this, step)} // eslint-disable-line
                confirmTitle={step.on_confirm_back_title}
                confirmDescription={step.on_confirm_back_description}
                immFinalButton={current_contract.hireBtnLabel}
                finishButton={true}
                nextButtonDisabled={this.state.nextButtonDisabled}
                cancelButton={true}
                onNextClick={this.handleNextClick}
            >
                <span className='fioc-view__wizard__title'>
                    {title}
                    <span className='fioc-view__wizard__title__details'>
                        {subtitle}
                        {formError}
                        {description}
                    </span>
                </span>
                <ContractComponent
                    key={'first'}
                    component={component}
                    localState={this.state}
                    contractWizard={contractWizard}
                    current_contract={current_contract}
                    nextStep={this.nextStep}
                    disableFinishButton={this.disableFinishButton}
                />
                {disclaimerPersonalInfo}
                {stepFooter}
            </WizardStep>
        );
    }

    buildStepFooter(step) {
        return <HTMLSafeInjector message={step.footer_text} />;
    }

    handleValidateStep(step) {
        fiocErrorTagging("error en el formulario");
        validateStep(step);
    }

    buildSteps() {
        const {
            contractWizard,
            setVisibleStep,
            setWillCancel,
            validateStep,
            immScreen,
        } = this.props;

        const stepsAmount = current_contract.define_steps + 1;//UNCOMMENT WHEN OTP NEEDED
        const visibleStep = contractWizard.get('visibleStep');
        const actions = {
            cancel: immScreen.get('isDesktop') ? this.handleCancel : this.handleConfirmFinishFIOC,
            finish: this.handleHireContract,
            previousClick: fiocPreviousButtonTagging,
            setVisibleStep,
            setWillCancel,
            validateStep,
        };

        let immSteps = [];
        let steps = [this.buildStep(current_contract.steps[0])];
        steps[1] = this.buildConfirmationStep();//UNCOMMENT WHEN OTP NEEDED

        for (let i = 0; i < stepsAmount; i++) {
            let m = new Map();
            m.set('valid', true);
            immSteps.push(m);
        }

        immSteps = Immutable.fromJS(immSteps);

        return (
            <Wizard
                wizardClass='fioc-view__wizard'
                actions={actions}
                immSteps={immSteps}
                stepsAmount={stepsAmount}
                visibleStep={visibleStep}
            >
                {steps}
            </Wizard>
        );
    }

    handleComponentDidMountCallback() {
        const { signaturePattern } = this.props;

        fiocStepTwoViewTagging();
        if(signaturePattern && signaturePattern.get('isDeviceTrusted')) {
            fiocIntroduceOTPTagging();
        }
    }

    buildConfirmationStep() {//UNCOMMENT WHEN OTP NEEDED
        const {
            contractWizard,
            updateConfirmationCheckboxes,
            immProfileFields,
            signaturePattern
        } = this.props;
        const {
            alertMessage,
            code_op: signaturePatternCode,
            confirmationLabel,
            hasContractPdfViewer,
        } = current_contract;
        const params = {};
        const confirmationCheckboxes = contractWizard.get('confirmationCheckboxes');
        const confirmationMessage = contractWizard.get('confirmationMessage');
        const isLoading = contractWizard.get('isLoading');
        const handleDocument = {};

        return (
            <WizardStep
                key='last'
                addLoadingBehaviour={true}
                position='last'
                cancelButton={true}
                immFinalButton='profileFioc-buttonUpdate'
                isLoading={isLoading}
            >
                <ContractConfirmationStep
                    alertMessage={alertMessage}
                    immProfileFields={immProfileFields}
                    confirmationCheckboxes={confirmationCheckboxes}
                    confirmationMessage={confirmationMessage}
                    contractWizard={contractWizard}
                    signaturePatternCode={signaturePatternCode}
                    params={params}
                    updateConfirmationCheckboxes={updateConfirmationCheckboxes}
                    warningMessage='profileFioc-confirmationStepText'
                    wizardState={contractWizard}
                    current_contract={current_contract}
                    operativeName={'operatives-profileFiocUpdate'}
                    confirmationLabel={confirmationLabel}
                    handleDocument={handleDocument}
                    hasContractPdfViewer={hasContractPdfViewer}
                    sendPrecontractualDocumentMail={() => {}}
                    handleSendNewOtp={fiocRequestNewOTPTagging}
                    immSignaturePattern={signaturePattern}
                    onComponentDidMountCallback={this.handleComponentDidMountCallback}
                    handleSMSInputClickCallback={fiocIntroduceOTPTagging}
                    handleInputSMSErrorTagging={fiocOTPErrorTagging}
                />
            </WizardStep>
        );
    }

    handleConfirmFinishFIOC = () => {
        const visibleStep = this.props.contractWizard.get('visibleStep');
        if(visibleStep === 1) {
            buttonCancelTagging();
        } else {
            fiocCancelButtonTagging();
        }
        window.location.href = '/myprofile/global/';
    };

    buildSuccessful() {
        const goBackButton = {
            label: this.props.immScreen.get('isDesktop') ? <FormattedText value='profileFioc-goBackButton' /> :
                <FormattedText value='common-accept' />,
            url: this.props.immScreen.get('isDesktop') ? '/myprofile/edit' : null,
        };

        return (
            <WizardSuccess
                mainButton={goBackButton}
                successMessage={formatText('profileFioc-successStepTitle')}
                {...(!this.props.immScreen.get('isDesktop') && { onMainButtonClick: this.handleConfirmFinishFIOC })}
                onComponentDidMountCallback={fiocUpdateDocumentSuccessTagging}
                onMainButtonClick={ this.handleReturnToGlobalPositionClick }
            >
                <PendingDocumentation
                    immFiocDocumentation={this.props.immFiocDocumentation}
                />
            </WizardSuccess>
        );
    }

    handleCancel() {
        const visibleStep = this.props.contractWizard.get('visibleStep');
        if(visibleStep === 1) {
            buttonCancelTagging();
        } else {
            fiocCancelButtonTagging();
        }
        const redirectTo = current_contract.onCancelURL || '/myprofile/global/';
        this.props.history.push(redirectTo);
    }

    handleConfirmBackClick(step) {
        if (contractBuilder[step.on_confirm_back_click]) {
            const { contractWizard, updateCardDetails } = this.props;
            const cardDetails = contractBuilder[step.on_confirm_back_click](contractWizard);

            updateCardDetails(cardDetails.toJS());
        }
    }

    handleConfirmLeave() {
        fiocLeaveModalTagging();
        const redirectTo = current_contract.onCancelURL || '/myprofile/global/';
        this.props.reset();
        this.props.history.push(redirectTo);
    }

    isReady() {
        const { contractWizard } = this.props;

        return (
            contractWizard.get('submitSuccessful') ||
            contractWizard.get('error') ||
            this.state.card_details.dontShowPreleaveModal
        );
    }

    nextStep() {
        this.props.toNextStep(this.props.contractWizard.get('visibleStep'));
    }

    render() {

        const { contractWizard, immScreen } = this.props;
        const { showHelpBar, title } = current_contract;
        const headerSubPage = this.buildHeaderSubPage();
        const preLeaveModal = this.buildPreLeaveModal();
        const isDesktop = immScreen.get('isDesktop');

        const showHelpSection = showHelpBar ?
            (
                <div className='col-xs-6 col-md-12 grid-view--fix-cell-separation'>
                    <CallMeBack context='contracts' modifier='contracts-view' pageTitle={getFinalTitle(title)} hasEntrance={false} />
                </div>
            ) : '';

        let content;

        if (contractWizard.get('error')) {
            content = (
                <div className='col-xs-12 col-md-offset-1 col-md-10'>
                    {this.buildError()}
                </div>
            );

        } else if (contractWizard.get('submitSuccessful')) {
            content = (
                <div className='col-xs-12 col-md-offset-1 col-md-10'>
                    {this.buildSuccessful()}
                </div>
            );

        } else {
            const sidebarText = (
                <div className='fioc-view__information-box-body'>
                    <div className='fioc-view__information-box-info-icon'>
                        <OKIconIllustrative icon='info' product='banking' />
                    </div>
                    <ul className='fioc-view__information-box-list'>
                        <li className='fioc-view__information-box-item'>
                            <FormattedText value='profileFioc-customerKnowledgeFormBulletOne' />
                        </li>
                        <li className='fioc-view__information-box-item'>
                            <FormattedText value='profileFioc-customerKnowledgeFormBulletTwo' />
                        </li>
                        <li className='fioc-view__information-box-item'>
                            <FormattedText value='profileFioc-customerKnowledgeFormBulletThree' />
                        </li>
                    </ul>
                </div>
            );
            content = (
                <div>
                    {!isDesktop &&
                        <div className='mobile-fioc-header'>
                            <img
                                className='openbank-logo'
                                src={openbankLogo}
                            />
                        </div>
                    }
                    <div className='col-xs-12 col-md-8'>
                        {this.buildSteps()}
                    </div>
                    {isDesktop &&
                        <div className='col-xs-12 col-md-4'>
                            <div className='row'>
                                <div className='col-xs-6 col-md-12 grid-view--variable-cell-separation'>
                                    <ContactInfoBox
                                        boxTitle={formatText('profileFioc-customerKnowledgeFormTitle')}
                                        boxBody={sidebarText}
                                    />
                                </div>
                                {showHelpSection}
                            </div>
                        </div>
                    }
                </div>
            );
        }

        return (
            <div className={`${!isDesktop && 'fioc-view-mobile'}`}>
                {
                    isDesktop && <div className='container-fluid'>
                        <div className='row'>
                            <OKCover size='medium' section='pg' customClass='col-xs-12'>
                                {headerSubPage}
                            </OKCover>
                        </div>
                    </div>
                }
                <div className='grid-view__body'>
                    <div className='container-fluid'>
                        <div className={`row ${isDesktop && 'grid-view--content-position-negative'}`}>
                            {content}
                        </div>
                    </div>
                </div>
                {preLeaveModal}
            </div>
        );
    }
}

FiocView.propTypes = {
    contractWizard: PropTypes.object.isRequired,
    fiocUpdate: PropTypes.func.isRequired,
    getCountries: PropTypes.func.isRequired,
    getProfessionCnae: PropTypes.func.isRequired,
    getProfessionCnaeCategory: PropTypes.func.isRequired,
    getProfessionCnaeUncategorized: PropTypes.func.isRequired,
    getProfessionCno: PropTypes.func.isRequired,
    getSectorSubcategories: PropTypes.func.isRequired,
    handleCancelClick: PropTypes.func,
    history: PropTypes.object.isRequired,
    immFiocDocumentation: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object,
    immInterstitials: PropTypes.object,
    loadState: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    setContract: PropTypes.func.isRequired,
    setInProgress: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    signaturePattern: PropTypes.object.isRequired,
    toNextStep: PropTypes.func,
    updateCardDetails: PropTypes.func.isRequired,
    updateConfirmationCheckboxes: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
};

module.exports.constructor = FiocView;
module.exports.FiocView = connect(
    state => ({
        contractWizard: state.contracts,
        immFiocDocumentation: state.fiocDocumentation,
        immProfileFields: state.profile,
        signaturePattern: state.signaturePattern,
        immScreen: state.screen,
        immInterstitials: state.interstitialGeneric,
    }),
    {
        fiocUpdate: contractsActions.fiocUpdate,
        getCountries: contractsActions.getCountries,
        getFiocContent: interstitialsActions.getFiocContent,
        getProfessionCnae: contractsActions.getProfessionCnae,
        getProfessionCno: contractsActions.getProfessionCno,
        getProfessionCnaeUncategorized: contractsActions.getProfessionCnaeUncategorized,
        getProfessionCnaeCategory: contractsActions.getProfessionCnaeCategory,
        getSectorSubcategories: contractsActions.getSectorSubcategories,
        loadState: contractsActions.loadState,
        reset: contractsActions.reset,
        setContract: contractsActions.setContract,
        setInProgress: contractsActions.setInProgress,
        setVisibleStep: contractsActions.setVisibleStep,
        setWillCancel: contractsActions.setWillCancel,
        toNextStep: contractsActions.toNextStep,
        updateCardDetails: contractsActions.updateCardDetails,
        updateConfirmationCheckboxes: contractsActions.updateConfirmationCheckboxes,
        validateStep: contractsActions.validateStep,
        parseFiocData: fiocDocumentation.parseFiocData,
    },
)(withRouter(FiocView));
